<template>
    <div>
        <div class="pb-6 diagonal pb-8 pt-0 pt-md-5" >
            <div class="row">
            </div>
        </div>
        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="card-header border-0">
                            <div class="row align-items-center">
                                <div class="col"><h3 class="mb-0">Prijaté formuláre</h3></div>
                                <div class="col text-right">

                                </div>
                            </div>
                        </div>
                        <div class="table-responsive">
                            <a-table
                                    :columns="columns"
                                    :dataSource="submissions"
                                    :loading="loading"
                                    :rowKey="record => record.id"
                                    class="table-flush">
                                <div
                                        slot="filterDropdown"
                                        slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                                        style="padding: 8px"
                                >
                                    <a-input
                                            v-ant-ref="c => searchInput = c"
                                            :placeholder="`Search ${column.dataIndex}`"
                                            :value="selectedKeys[0]"
                                            @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                                            @pressEnter="() => handleSearch(selectedKeys, confirm)"
                                            style="width: 188px; margin-bottom: 8px; display: block;"
                                    />
                                    <a-button
                                            type="primary"
                                            @click="() => handleSearch(selectedKeys, confirm)"
                                            icon="search"
                                            size="small"
                                            style="width: 90px; margin-right: 8px"
                                    >Search
                                    </a-button
                                    >
                                    <a-button @click="() => handleReset(clearFilters)" size="small" style="width: 90px"
                                    >Reset
                                    </a-button
                                    >
                                </div>
                                <a-icon
                                        slot="filterIcon"
                                        slot-scope="filtered"
                                        type="search"
                                        :style="{ color: filtered ? '#108ee9' : undefined }"
                                />
                                <template slot="customRender" slot-scope="text">
      <span v-if="searchText">
        <template
                v-for="(fragment, i) in text.toString().split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))"
        >
          <mark
                  v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                  :key="i"
                  class="highlight"
          >{{fragment}}</mark
          >
          <template v-else>{{fragment}}</template>
        </template>
      </span>
                                    <template v-else
                                    >{{text}}
                                    </template
                                    >
                                </template>
                                <template slot="user_role" slot-scope="user">
                                    <a class="text-left text-lowercase" :href="'role/'+ role"
                                       v-for="(role,index) in JSON.parse(user.type_id)"> {{roleops[role]}}<span
                                            v-if="index+1 < JSON.parse(user.type_id).length">, </span></a>
                                </template>
                                <template slot="vals" slot-scope="vals">

     <table class="data-table">
         <tr><th :key="vv.title" v-for="vv in vals" v-html="vv.title"></th></tr>
         <tr><td :key="vv.title+':'+vv.value" v-for="vv in vals" v-html="vv.value"></td></tr>

     </table>
                                </template>
                                <template slot="date" slot-scope="datedata">
                                    <span>{{formatDate(datedata)}}</span>
                                </template>

                            </a-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    import {dataService} from "../_services";
    import {Popconfirm} from "ant-design-vue"
    import {Button, Input, Icon} from 'ant-design-vue';

    import moment from 'moment'

    export default {
        name: "submissions",
        props: ["id"],
        components: {
            "a-popconfirm": Popconfirm,
            "a-button": Button,
            "a-icon": Icon,
            "a-input": Input
        },
        data() {
            return {
               submissions: [],
                loading: false,
                colorsto: JSON.parse(localStorage.colors),
                columns: [
                    {
                        title: '#',
                        dataIndex: 'id',
                        key: 'id',
                        sortable: true,
                    },
                    {
                        title: 'Odoslané',
                        key: 'created',
                        dataIndex: 'created',
                        scopedSlots: {customRender: 'date'},
                    },
                    {
                        title: 'data',
                        key: 'vals',
                        scopedSlots: {customRender: 'vals'},
                        dataIndex: 'vals',
                    },

                ],
            };
        },

        mounted() {
            this.$nextTick(() => {
                this.fetch();

            })

        },
        methods: {
            handleSearch(selectedKeys, confirm) {
                confirm();
                this.searchText = selectedKeys[0];
                console.log(this.searchText);
            },
            formatDate: function (dt) {
                return moment.unix(dt).format('D.M.YYYY H:mm')

            },
            handleReset(clearFilters) {
                clearFilters();
                this.searchText = '';
            },
            fetch() {
                this.loading = true;
                dataService.axiosFetch(this.$options.name,this.id).then(results => {
                  this.submissions = results.submissions;
                  this.columns = results.columns;
                    this.loading = false;

                });
            }

        },
    };
</script>

<style>
    ul.ant-pagination {
        margin-top: 0;
        margin-bottom: 1em;
    }


    .highlight {
        background-color: rgb(255, 192, 105);
        padding: 0px;
    }
    .data-table td,   .data-table th
    {border:1px solid #e8e8e8 !important;padding:10px;}
.data-table th
{font-size:12px;}
    .ant-table-pagination.ant-pagination {
        margin-bottom: 40px;
        margin-right: 20px;
    }

    .ant-pagination5-item {
        border: 0;
    }

    .ant-table {
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);
        margin-bottom: 20px;
    }

    .ant-pagination5-item a, .ant-pagination5-prev a, .ant-pagination5-next a, .ant-pagination5-jump-prev a, .ant-pagination5-jump-next a {
        -webkit-box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
        box-shadow: 0 7px 14px rgba(50, 50, 93, 0.1), 0 3px 6px rgba(0, 0, 0, 0.08);
        border: 0;
    }

    .ant-pagination5-item a, .ant-pagination5-prev a, .ant-pagination5-next a {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        padding: 0;
        margin: 0 3px;
        border-radius: 50% !important;
        width: 36px;
        height: 36px;
        font-size: 0.875rem;
    }


    .ant-pagination5-item.ant-pagination5-item-active a {
        z-index: 1;
        color: #fff;
        background-color: #5e72e4;
        border-color: #5e72e4;
    }

    .ant-pagination5-item-link.ant-pagination5-disabled a {
        color: #8898aa;
        pointer-events: none;
        cursor: auto;
        background-color: #fff;
        border-color: #dee2e6;
    }

</style>
